import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Role } from '../../models/role';
import { UserRoleService } from '../../services/user-role.service';

@Injectable({
  providedIn: 'root'
})
export abstract class RoleGuard implements CanActivate {
  protected abstract roles: Role[];

  constructor(
    private readonly userRoleService: UserRoleService,
    private readonly router: Router
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userRoleService
      .hasRole$(this.roles)
      .pipe(switchMap((hasRole) => (hasRole ? of(true) : from(this.router.navigate(['403'])))));
  }
}
